import { BootcampProductAPIStat, BootcampProductUIStat } from '~/redux/apis/user-stats-api'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'

import { getVideoProgressData } from '../utils/get-video-progress-data.utils'

export default function useBootcampProductCardStats(productStat: BootcampProductAPIStat): BootcampProductUIStat {
  const {
    subjectTitle,
    videoCourseName,
    id,
    bossBattleUrl,
    timeSpent,
    summary: {
      correctAnswersCount,
      incorrectAnswersCount,
      completedChestsCount,
      totalChestsCount,
      completedBossBattlesCount,
      totalBossBattlesCount,
      totalSetsCount,
      setsCompletedCount,
      totalCorrectAnswersCount,
      totalIncorrectAnswersCount,
    },
    video: {
      totalCount: totalVideoCount,
      watchedCount: watchedVideoCount,
      watchedDuration: videoWatchedDuration,
      videoLinks,
    },
    levels,
    firstLevelName,
    supportsCurrentLocale,
  } = productStat

  const { days: timeSpentDays, hours: timeSpentHours, minutes: timeSpentMinutes } = convertMsToDayHourMinute(timeSpent)
  const correctAnswerPercentage = Math.floor(
    (correctAnswersCount / (correctAnswersCount + incorrectAnswersCount)) * 100,
  )
  const formatCorrectAnswerPercentage = isNaN(correctAnswerPercentage) ? 0 : correctAnswerPercentage
  const isBossBattleComplete = completedBossBattlesCount / totalBossBattlesCount === 1
  const videoProgressBarData = getVideoProgressData(watchedVideoCount, totalVideoCount, videoLinks)
  const {
    days: videoWatchedDays,
    hours: videoWatchedHours,
    minutes: videoWatchedMinutes,
  } = convertMsToDayHourMinute(videoWatchedDuration ?? 0)
  const activitySetsProgress = Math.floor((setsCompletedCount / totalSetsCount) * 100)
  const formatActivitySetsProgress = !isNaN(activitySetsProgress) ? activitySetsProgress : 0
  const totalAnswered = totalCorrectAnswersCount + totalIncorrectAnswersCount
  const productHref = `/${id.split('.').join('/')}/1/${firstLevelName}`

  // bootcamp progress works like this
  // see more: https://github.com/houseofmath/hom-frontend/blob/7da222beb9787db962378fcaa4829dc3a4fa8ed0/packages/hom-frontend/src/bootcamp/utils/getBootcampProgress.utils.ts#L58
  const progressBarPercentage = (completedChestsCount / totalChestsCount) * 90 + (isBossBattleComplete ? 10 : 0)

  return {
    id,
    subjectTitle,
    videoCourseName,
    bossBattleUrl,
    timeSpent: {
      days: timeSpentDays,
      hours: timeSpentHours,
      minutes: timeSpentMinutes,
    },
    activitiesSummary: {
      completedBossBattlesCount,
      totalBossBattlesCount,
      totalSetsCount,
      setsCompletedCount,
    },
    correctAnswerPercentage: formatCorrectAnswerPercentage,
    isBossBattleComplete,
    progressBarPercentage,
    activitySetsProgress: formatActivitySetsProgress,
    videoProgress: {
      days: videoWatchedDays,
      hours: videoWatchedHours,
      minutes: videoWatchedMinutes,
    },
    video: { totalCount: totalVideoCount, watchedCount: watchedVideoCount, watchedDuration: videoWatchedDuration },
    levels,
    videoProgressBarData,
    totalAnswered,
    productHref,
    supportsCurrentLocale,
  }
}
